import { ProductUsps } from '@kizi/comparator-components';
import { Div, P } from '@kizi/core-components';
import React from 'react';

export const ProductCardMainSection = ({ data, productUspsContent }) => {
  const subscriptionTitle = data?.subscriptionName;
  const discountInformation = data?.discountInformation;

  return (
    <Div flex={1} display={'flex'} flexDirection={'column'} gridGap={'8px'}>
      {subscriptionTitle && (
        <P variant="bodyV2" fontWeight={700}>
          {subscriptionTitle}
        </P>
      )}
      {discountInformation && (
        <Div
          px={'8px'}
          width="fit-content"
          borderRadius="100px"
          background="#0DA06F"
        >
          <P variant="regularV2" color="white">
            {discountInformation}
          </P>
        </Div>
      )}
      <ProductUsps
        {...productUspsContent}
        css={{
          fontSize: '16px',
          lineHeight: '24px',
        }}
        containerProps={{
          'svg': {
            width: '24px',
            height: '24px !important',
          },
        }}
      />
    </Div>
  );
};
